import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import { RegisterResponse, newItem } from 'types';

class RegisterService {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  getDataStoreFields(params: { appId: string; dataStoreId: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${params.dataStoreId}/fields`,
    };
    return this.axios(request);
  }

  newOrder(data: newItem): AxiosPromise<RegisterResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/${data.dataStoreId}/items/new`,
      data: {
        item: data.item,
        return_item_result: data.return_item_result,
      },
    };
    return this.axios(request);
  }
  candidateBilling(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_billing_candidate/items/new`,
      data: {
        item: {
          cpap_id: param,
        },
      },
    };
    return this.axios(request);
  }
  excecuteCPAP(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_billing_candidate/items/action/${param.item_id}/${param.action}`,
      data: {
        is_force_update: true,
      },
    };
    return this.axios(request);
  }
  searchCandidate(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_billing_candidate/items/search`,
      data: {
        page: 1,
        per_page: 20,
        conditions: param.conditions,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }
  getTokenDocurain(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/m_app_options/items/search`,
      data: {
        page: 1,
        per_page: 0,
        conditions: param.conditions,
        use_display_id: true,
      },
    };
    return this.axios(request);
  }
}

export default RegisterService;
